<sc-lateral-menu-wrapper [isOpen]="!!openMenu" (closeModal)="closeLateralMenu()">
    <sc-pas-selector *ngIf="!!openMenu" title="Seleccione un productor" backToBranchIconSrc="" [runAnimation]="openMenu"
        [rowData]="producers" (onClick)="handleOnClickPasSelector($event)">
    </sc-pas-selector>
</sc-lateral-menu-wrapper>

<div class="retirement-insurance-background"></div>
<div class="retirement-insurance-container">
    <div>
        <img class="logo-sc" src="assets/images/san-cristobal-retiro.png" alt="San Cristóbal Retiro">
    </div>
    <div>
        <p class="main-title title">
            Seguros de Retiro
        </p>
    </div>
    <div>
        <p class="subtitle section-title">
            Seleccione un productor para poder operar.
        </p>
        <div class="button-container">
            <sc-button (onClick)="openPASSelector()" id="continueToPAS" [loading]="loading">Continuar</sc-button>
        </div>
    </div>
</div>